import { render } from "./TagTypeComponent.vue?vue&type=template&id=4bd79920&scoped=true"
import script from "./TagTypeComponent.vue?vue&type=script&lang=js"
export * from "./TagTypeComponent.vue?vue&type=script&lang=js"

import "./TagTypeComponent.vue?vue&type=style&index=0&id=4bd79920&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd79920"]])

export default __exports__